import { UserRole } from '@citrite/sf-api';
import { projectsExtensionSlots } from '@sharefiledev/projects-pilet-sdk';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { shouldDisplayIntegrations } from '../checkIntegrationsAST';
import { ExtensionType } from '../types';
import { AsyncFileExportExtension } from '.';

export const configureFileExportProjectsExtension = (app: PiletApi) => {
	const { account, user } = app.sf.piletUserContext.get();

	if (shouldDisplayIntegrations(app) && !user.Roles.includes(UserRole.Client)) {
		app.registerExtension(projectsExtensionSlots.fileExportButton, ({ params }) => {
			// TODO: remap at the projects level
			const files = params.files.map(file => ({
				name: file.fileName,
				rid: file.shareFileStreamId,
			}));

			return (
				<AsyncFileExportExtension
					account={account}
					files={files}
					extensionType={ExtensionType.PROJECTS}
				/>
			);
		});
	}
};
